module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightIt.woff?eb687487a69d8f25f0ef7735ff9cf614";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightIt.woff
// module id = 1395
// module chunks = 0